import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Statistic, Header, Popup, Icon } from 'semantic-ui-react';
import { colors } from 'utils/colors';
import { Table, Score } from 'components';
import { translation } from '../../../Translation/scorecard';

@connect((state) => ({
  french: state.Storage.language === 'fr',
}))
export default class Income extends Component {
  getClass = (row) => {
    if (row.isExcluded) {
      return 'negative';
    }

    return false;
  };

  isLinked = (data) => {
    if (!data || !data.portfolio) {
      return false;
    }

    if (
      data.portfolio.portfolio_type === 'custom' ||
      data.portfolio.portfolio_type === 'quantified'
    ) {
      return true;
    }

    return data.portfolio.is_linked;
  };

  render() {
    const { analytics } = this.props;
    const { data } = analytics;
    const { french } = this.props;
    const language = french ? 'fr' : 'en';

    return (
      <Container>
        <Score
          name={`${translation[language].INCOME} `}
          score={`${data.score.Income[0]}%`}
          grade={data.score.Income[1]}
          portfolio={data.portfolio}
          pdf
        />

        <p>
          {french
            ? "Le revenu se réfère aux dividendes en espèces d'une action ou aux distributions en espèces d'un FNB ou d'un fonds commun de placement."
            : 'Income refers to cash dividends from a stock, or cash distributions from an ETF or a mutual fund.'}
        </p>
        <p>
          {french
            ? "Que vous souhaitiez un score de revenu élevé dépend de votre objectif d'épargne. Si vous investissez à long terme, ou si vous ne dépendez pas de votre portefeuille pour les dépenses quotidiennes, un portefeuille à revenu élevé n'est pas nécessaire."
            : 'Whether you desire a high income score depends on your saving objective. If you are investing for the long term, or if you are not dependent on your portfolio for everyday expenses, a high income portfolio is not necessary.'}
        </p>

        <Statistic
          size="tiny"
          label={translation[language].WEIGHTED_AVERAGE_YIELD}
          value={`${(data.portYield * 100).toFixed(2)}%`}
          style={{ display: 'block' }}
        />

        <Header
          dividing
          size="medium"
          content={
            french
              ? 'Rendement de distribution du portefeuille'
              : 'Portfolio Distribution Yield'
          }
        />

        <Table basic fixed textAlign="center">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign="left">
                {translation[language].ASSET}
              </Table.HeaderCell>
              <Table.HeaderCell width={2}>
                {translation[language].WEIGHT}
              </Table.HeaderCell>
              <Table.HeaderCell width={2}>
                {translation[language].YIELD}&nbsp;
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {data.tickersOriginal.map((row) => (
              <Table.Row key={row.ticker} negative={row.isExcluded}>
                <Table.Cell textAlign="left">
                  {this.isLinked(data) ? row.name : row.wsName}
                </Table.Cell>
                <Table.Cell>
                  {this.getClass(row) ? (
                    <Error>
                      <span>{Math.round(row.weight * 10000) / 100}%</span>
                      <Popup
                        trigger={<Icon name="exclamation circle" />}
                        position="bottom center"
                        wide
                        content={
                          <div>
                            <strong>{row.name}</strong>{' '}
                            {french
                              ? "a été exclu de l'analyse car il n'a pas suffisamment d'historique."
                              : 'has been excluded in the analysis because it has insufficient history.'}
                          </div>
                        }
                      />
                    </Error>
                  ) : (
                    `${Math.round(row.weight * 10000) / 100}%`
                  )}
                </Table.Cell>
                <Table.Cell>
                  {Math.round(row.dist_yield * 10000) / 100}%
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </Container>
    );
  }
}

Income.propTypes = {
  analytics: PropTypes.object.isRequired,
  french: PropTypes.bool,
};

Income.defaultProps = { french: false };

const Error = styled.div`
  position: relative;
  text-align: center;

  span {
    font-size: 1rem;
  }

  i {
    color: ${colors.red};
    font-size: 1.4rem;
    position: absolute;
    top: 0;
    left: -1.5rem;
  }
`;

const Container = styled.div`
  min-height: 100%;
  padding: 2rem 2rem 1rem 2rem;
`;
